import styled from 'styled-components';

const Wrapper = styled.section`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  margin-bottom: 1.5rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid #e5e7eb;
  position: sticky;
  top: 108px;
  background: var(--clr-background, #f6f8f8);
  z-index: 20;
  padding-top: 0.5rem;
  margin-top: -0.5rem;

  @media (min-width: 992px) {
    position: static;
    padding-top: 0;
    margin-top: 0;
  }

  .toolbar-left {
    display: flex;
    align-items: center;
    gap: 0.75rem;
  }

  .toolbar-right {
    display: flex;
    align-items: center;
    gap: 0.75rem;
  }

  /* Mobile Filter Button */
  .mobile-filter-btn {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.5rem 0.875rem;
    background: #ffffff;
    border: 1px solid #e5e7eb;
    border-radius: 0.5rem;
    font-family: var(--font-body), system-ui, sans-serif;
    font-size: 0.8125rem;
    font-weight: 500;
    color: #374151;
    cursor: pointer;
    transition: all 0.2s;
    position: relative;

    svg {
      width: 16px;
      height: 16px;
    }

    span:not(.filter-badge) {
      display: none;
    }
  }

  .mobile-filter-btn:hover {
    border-color: var(--clr-olive, #6b7b5c);
  }

  .mobile-filter-btn .filter-badge {
    position: absolute;
    top: -6px;
    right: -6px;
    min-width: 16px;
    height: 16px;
    background: var(--clr-olive, #6b7b5c);
    color: #ffffff;
    font-size: 0.625rem;
    font-weight: 600;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 3px;
  }

  @media (min-width: 480px) {
    .mobile-filter-btn span:not(.filter-badge) {
      display: inline;
    }
  }

  @media (min-width: 992px) {
    .mobile-filter-btn {
      display: none;
    }
  }

  /* Mobile Sort Dropdown */
  .mobile-sort-container {
    display: flex;
    align-items: center;
    position: relative;

    .mobile-sort-select {
      appearance: none;
      padding: 0.5rem 2rem 0.5rem 0.75rem;
      background: #ffffff;
      border: 1px solid #e5e7eb;
      border-radius: 0.5rem;
      font-family: var(--font-body), system-ui, sans-serif;
      font-size: 0.8125rem;
      font-weight: 500;
      color: #374151;
      cursor: pointer;
      transition: all 0.2s;
      max-width: 130px;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }

    .mobile-sort-select:focus {
      outline: none;
      border-color: var(--clr-olive, #6b7b5c);
    }

    .sort-chevron {
      position: absolute;
      right: 0.625rem;
      pointer-events: none;
      color: #6b7280;
    }
  }

  @media (min-width: 768px) {
    .mobile-sort-container {
      display: none;
    }
  }

  /* Product count */
  .product-count {
    font-size: 0.8125rem;
    color: #6b7280;
    margin: 0;
    white-space: nowrap;
    
    span {
      font-weight: 600;
      color: #111718;
    }
  }

  @media (min-width: 768px) {
    .product-count {
      font-size: 0.875rem;
    }
  }

  /* Sort container */
  .sort-container {
    display: none;
    align-items: center;
    gap: 0.5rem;
  }

  @media (min-width: 768px) {
    .sort-container {
      display: flex;
    }
  }

  .sort-label {
    font-size: 0.8125rem;
    font-weight: 500;
    color: #6b7280;
    white-space: nowrap;
    display: none;
  }

  @media (min-width: 992px) {
    .sort-label {
      display: block;
    }
  }

  .sort-input {
    padding: 0.5rem 0.75rem;
    padding-right: 2rem;
    background: #ffffff;
    border: 1px solid #e5e7eb;
    border-radius: 0.5rem;
    font-size: 0.8125rem;
    color: #111718;
    cursor: pointer;
    transition: all 0.2s;
    min-width: 140px;
  }

  @media (min-width: 992px) {
    .sort-input {
      min-width: 160px;
      font-size: 0.875rem;
    }
  }

  .sort-input:focus {
    outline: none;
    border-color: var(--clr-olive, #6b7b5c);
  }

  /* View toggle */
  .btn-container {
    display: flex;
    align-items: center;
    border: 1px solid #e5e7eb;
    border-radius: 0.5rem;
    overflow: hidden;
    
    button {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 2rem;
      height: 2rem;
      background: #ffffff;
      border: none;
      color: #9ca3af;
      cursor: pointer;
      transition: all 0.2s;
      
      svg {
        font-size: 0.875rem;
      }
    }

    button + button {
      border-left: 1px solid #e5e7eb;
    }
    
    button:hover {
      color: var(--clr-olive, #6b7b5c);
      background: rgba(107, 123, 92, 0.05);
    }
    
    button.active {
      background: var(--clr-olive, #6b7b5c);
      color: #ffffff;
    }
  }

  @media (min-width: 768px) {
    .btn-container button {
      width: 2.25rem;
      height: 2.25rem;

      svg {
        font-size: 1rem;
      }
    }
  }
`;

export default Wrapper;
